import { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { DownloadIcon, IconButton, toast } from '@utilities';

import { downloadDOCXFile } from './utilities/helpers';

const DownloadDOCXButton = ({
  includeTranslations = false,
  isDisabled = false,
  survey,
  tooltip,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const user = useSelector((state) => state?.user?.data);
  const isButtonDisabled = isDownloading || isDisabled;
  const buttonTooltip =
    (isDownloading ? 'Generating Word document...' : tooltip) || 'Download Survey as Word Document';

  const handleDownload = async () => {
    if (isButtonDisabled) return;
    setIsDownloading(true);
    try {
      await downloadDOCXFile({ includeTranslations, survey, userEmail: user?.email });
    } catch (error) {
      console.error('DOCX generation error:', error);
      toast.error(`Failed to generate Word document${error?.message ? `: ${error.message}` : ''}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <IconButton isDisabled={isButtonDisabled} onClick={handleDownload} tooltip={buttonTooltip}>
      <DownloadIcon />
    </IconButton>
  );
};

DownloadDOCXButton.propTypes = {
  includeTranslations: PropTypes.bool,
  isDisabled: PropTypes.bool,
  survey: PropTypes.object.isRequired,
  tooltip: PropTypes.string,
};

export default DownloadDOCXButton;
